export const DYNAMIC_GALLERY_LOCAL_STORAGE_KEY = 'dynamic-gallery';
